import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldIcon } from './Icons';
export const GuaranteeSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-cream" ref={ref} data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="border-2 border-gold/30 p-6 md:p-16 rounded-sm text-center relative bg-white/50" data-id="element-47">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-cream p-2" data-id="element-48">
            <div className="bg-gold/10 p-4 rounded-full" data-id="element-49">
              <ShieldIcon className="w-10 h-10 text-gold" data-id="element-50" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-serif text-brown mb-6 mt-4" data-id="element-51">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-lg text-charcoal/80 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-52">
            Estoy tan segura de que este arte cambiará tu estado de ánimo, que
            si en una semana no sientes más calma y no has creado tu primer nudo
            con éxito, te devuelvo el 100% de tu dinero. Sin preguntas.{' '}
            <span className="font-medium text-brown" data-id="element-53">
              El riesgo es todo mío.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
};